/**
 * Footer tối giản — liên kết trang chủ, hotline và dòng hỗ trợ.
 */
import { Link } from 'react-router-dom';
import { APP_ROUTES } from '../../shared/constants/routes';
import { TEXT } from '../../shared/languages';

/** Footer công khai dùng chung cho PublicLayout. */
export const Footer = () => {
  const footer = TEXT.footer;

  return (
    <footer className="footer footer--minimal">
      <div className="container footer-minimal">
        <div className="footer-minimal-links">
          <Link to={APP_ROUTES.home}>{footer.allListings}</Link>
          <span>{footer.hotline}</span>
        </div>
        <span className="footer-minimal-copy">
          {footer.supportText}
        </span>
      </div>
    </footer>
  );
};
